<template>
    <div>
        <h3 class="m-b-30">Confirme seus dados pessoais</h3>

        <div class="row m-b-10">
            <div class="col-xs-12 col-sm-6">
                <div class="form-group" v-bind:class="{'has-error': errors.has('first_name')}">
                    <label for="first_name" class="control-label">Nome</label>
                    <input class="form-control" v-model="user.first_name" v-validate="'required'" name="first_name" type="text" maxlength="255" placeholder="Nome">
                    <span class="help-block text-left" v-show="errors.has('first_name')">
                        <strong>{{ errors.first('first_name') }}</strong>
                    </span>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6">
                <div class="form-group" v-bind:class="{'has-error': errors.has('last_name')}">
                    <label for="last_name" class="control-label">Sobrenome</label>
                    <input class="form-control" v-model="user.last_name" name="last_name" type="text" v-validate="'required'" maxlength="255" placeholder="Sobrenome">
                    <span class="help-block text-left" v-show="errors.has('last_name')">
                        <strong>{{ errors.first('last_name') }}</strong>
                    </span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-6">
                <div class="form-group" v-bind:class="{'has-error': errors.has('gender')}">
                    <label for="gender" class="control-label">Sexo</label>
                    <select class="form-control" v-model="user.gender" name="gender" v-validate="'required'">
                        <option value=""> Selecione </option>
                        <option value="M">Masculino</option>
                        <option value="F">Feminino</option>
                    </select>
                    <span class="help-block text-left" v-show="errors.has('gender')">
                        <strong>{{ errors.first('gender') }}</strong>
                    </span>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6">
                <div class="form-group" v-bind:class="{'has-error': errors.has('birthdate')}">
                    <label for="birthdate" class="control-label">Data de Nascimento</label>
                    <input id="birthdate" class="form-control" name="birthdate" v-mask="'##/##/####'" v-model="user.birthdate" type="tel" v-validate="'required|date_format:dd/MM/yyyy'">
                    <span class="help-block text-left" v-show="errors.has('birthdate')">
                        <strong>{{ errors.first('birthdate') }}</strong>
                    </span>
                </div>
            </div>
        </div>

        <p class="h4 m-b-15 m-t-20"><b>Telefones de Contato</b></p>

        <div class="row">
            <div class="col-xs-12 col-sm-6">
                <div class="form-group" v-bind:class="{'has-error': errors.has('phone')}">
                    <label for="phone" class="control-label">Telefone</label>
                    <input id="phone" class="form-control" v-mask="['(##) ####-####', '(##) #####-####']" name="phone" v-model="user.phone" type="tel">
                    <span class="help-block text-left" v-show="errors.has('phone')">
                        <strong>{{ errors.first('phone') }}</strong>
                    </span>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6">
                <div class="form-group" v-bind:class="{'has-error': errors.has('cellphone')}">
                    <label for="cellphone" class="control-label">Celular</label>
                    <input id="cellphone" class="form-control" name="cellphone" v-mask="['(##) ####-####', '(##) #####-####']" v-model="user.cellphone" v-validate="'required'" type="tel">
                    <span class="help-block text-left" v-show="errors.has('cellphone')">
                        <strong>{{ errors.first('cellphone') }}</strong>
                    </span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group" v-bind:class="{'has-error': errors.has('show_phone')}">
                    <label for="show_phone" class="control-label">
                        Como você quer exibir seus números de telefone?
                    </label>
                    <select class="form-control" name="show_phone" v-validate="'required'" v-model="user.show_phone" id="">
                        <option selected :value="null">Selecione</option>
                        <option :value="1">Não exibir meus números publicamente</option>
                        <option :value="2">Exibir apenas para quem eu estiver em contato</option>
                        <option :value="3">Exibir números de telefone para todos</option>
                    </select>
                    <span class="help-block text-left" v-show="errors.has('show_phone')">
                        <strong>{{ errors.first('show_phone') }}</strong>
                    </span>
                </div>
            </div>
        </div>

        <div class="row m-t-20">
            <div class="col-xs-12">
                <div class="form-group account-btn text-right">
                    <button @click="submitUser()" class="btn btn-bordered btn-success waves-effect waves-light w-lg ladda-button btn-submit" type="submit">Continuar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['user'],
    data() {
        return {
            form: this.user
        };
    },
    methods: {
        submitUser() {
            let _this = this;
            this.$validator.validateAll().then(function (res) {
                if (!res)
                    return false;

                let l = Ladda.create( document.querySelector('.account-btn .ladda-button') );
                l.start();

                axios.post('/user/update', _this.form).then(function (res) {
                    _this.$emit('proceed');
                    l.stop();
                }).catch(function(err) {
                    l.stop();
                    let response = err.response;
                    if (typeof response != 'undefined' && response.status == 422) {
                        _.forEach(response.data.errors, function(value, key) {
                            _this.$validator.errors.add({
                                field: key,
                                msg: value[0]
                            });
                        });
                    }
                });
            })
        }
    }
}
</script>